import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

type SortOrder = (typeof dataGridSortDirection)[number];

export function useAdminExamLocationListSearchParams() {
  const [
    { page, pageSize, sortOrder, locationName, provinceId },
    setAdminExamLocationRequestListSearchParams,
  ] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    provinceId: parseAsString.withDefault(''),
    locationName: parseAsString.withDefault(''),
  });

  const changePageNumber = (page: number) => {
    setAdminExamLocationRequestListSearchParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setAdminExamLocationRequestListSearchParams({ pageSize, page: 0 });
  };

  const changeSorting = ({ sortOrder }: { sortOrder: SortOrder | null }) => {
    setAdminExamLocationRequestListSearchParams({ sortOrder, page: 0 });
  };

  const changeLocationName = (locationName: string | null) => {
    setAdminExamLocationRequestListSearchParams({ locationName, page: 0 });
  };

  const changeProvinceId = (provinceId: string | null) => {
    setAdminExamLocationRequestListSearchParams({ provinceId, page: 0 });
  };

  return [
    { page, pageSize, sortOrder, locationName, provinceId },
    {
      changePageNumber,
      changePageSize,
      changeSorting,
      changeLocationName,
      changeProvinceId,
    },
  ] as const;
}
